import { commentsModel } from '../../api';
import { sendEventToJumbo } from '../../helpers/analytics';

export const SET_COMMENTS = 'SET_COMMENTS';
export const setComments = (comments) => ({
  type: SET_COMMENTS,
  comments,
});

export const getCommentsData = (params) => (dispatch, getState) => {
  const { commentsState } = getState();
  const { commentsList } = commentsState;
  let commentsObj = commentsList;
  const cartId = params['cart_id'];
  return commentsModel
    .getCommentsData(params)
    .then((response) => {
      if (!response) return;
      sendEventToJumbo('get_comments_success');
      commentsObj[cartId] = response;
      dispatch(setComments(commentsObj));
    })
    .catch((err) => {
      sendEventToJumbo('get_comments_failed', { err });
      console.log('comments error', err);
    });
};

export const addComments = (data) => (dispatch) => {
  return commentsModel
    .addComments(data)
    .then((response) => {
      if (!response) return;
      sendEventToJumbo('added_comment_successfully');
      return response;
    })
    .catch((err) => {
      sendEventToJumbo('failed_to_add_comment', { err });
      console.log('comments error', err);
    });
};
